import { render, staticRenderFns } from "./document-approval-list.vue?vue&type=template&id=5d2df343&scoped=true&"
import script from "./js/document-approval-list.js?vue&type=script&lang=js&"
export * from "./js/document-approval-list.js?vue&type=script&lang=js&"
import style0 from "./document-approval-list.vue?vue&type=style&index=0&id=5d2df343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2df343",
  null
  
)

export default component.exports